import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ActionsList from './actions';
import { map, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { BPAYDetailsService } from 'src/app/services/bpay-details.service';

@Injectable()
export class BPAYDetailsEffects {
  constructor(private store: Store<any>,
    private actions$: Actions,
    private router: Router,
    private service: BPAYDetailsService) {
  }

  getData$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsList.RequestAction),
    switchMap((action: any) => this.service.getAccountBPAYDetails(action.accountId)),
    map((data: any) => {
      return ActionsList.ResponseAction({ payload: data.data });
    })
  ));

}
